'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var FilterGroup = /*#__PURE__*/function (FilterGroup) {
  FilterGroup["SETTLEMENT_INCLUDES"] = "settlement-summary:settlement-includes";
  FilterGroup["SETTLEMENT_FROM"] = "settlement-summary:settlement-from";
  return FilterGroup;
}({});

exports.FilterGroup = FilterGroup;
